"use client";

import * as React from "react";
import { useEffect, useRef } from "react";
import { Slider as BaseSlider } from "@unreserved/ui/components/slider";

interface SliderProps extends React.ComponentProps<typeof BaseSlider> {
    "aria-label"?: string;
    "aria-labelledby"?: string;
}

export function Slider({
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    value,
    defaultValue,
    ...props
}: SliderProps) {
    const sliderRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!sliderRef.current) return;
        const thumbs = sliderRef.current.querySelectorAll('[data-slot="slider-thumb"]');

        if (thumbs.length === 0) return;

        thumbs.forEach((thumb, index) => {
            if (ariaLabelledBy) {
                thumb.setAttribute("aria-labelledby", ariaLabelledBy);
            }
            if (ariaLabel) {
                const label = thumbs.length > 1 ? `${ariaLabel} ${index + 1}` : ariaLabel;
                thumb.setAttribute("aria-label", label);
            }
        });
    }, [ariaLabel, ariaLabelledBy, value, defaultValue]);

    return (
        <div ref={sliderRef}>
            <BaseSlider
                {...props}
                value={value}
                defaultValue={defaultValue}
            />
        </div>
    );
}